import {
  aboutUs,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  legal,
  modelsComparison,
  studentGoodDeals,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const grConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, studentGoodDeals, hireExternal],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_gr',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/backmarket' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.gr/el-gr/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/el/articles/360026643854',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/el/articles/360034275533',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/el/categories/360002106194-%CE%95%CF%80%CE%B9%CF%83%CF%84%CF%81%CE%BF%CF%86%CE%AD%CF%82-%CE%91%CF%80%CE%BF%CE%B6%CE%B7%CE%BC%CE%B9%CF%8E%CF%83%CE%B5%CE%B9%CF%82-Reso-del-prodotto-e-rimborsi-Returns-Refunds--Retours-Remboursements-Retouren-en-terugbetalingen-Returns-refunds-',
        },
        help,
        buyingGuides,
        modelsComparison,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/el-gr/requests/new?ticket_form_id=12226993197084',
        },
      ],
      payment: { translationKey: 'paymentMethods' },
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'trustpilot',
          href: 'https://gr.trustpilot.com/review/backmarket.gr',
        },
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
